import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  bloodDrawContainer: {
    '& p': {
      margin: '0px'
    }
  },
  changeTransform: {
    '& #graph_bicarbonate-t-co-2': {
      '& svg': {
        x_axis: {
          transform: 'translate(-10px, 10px)'
        }
      }
    }
  }
});
export default useStyles;
